// **********************************************************
// Key Features
// **********************************************************

const keyFeaturesModule = document.querySelectorAll('.key-features');

if (keyFeaturesModule.length > 0) {
  let keyFeaturesEle = null;

  const initKeyFeaturesScrollMagic = () => {
    keyFeaturesEle = new ScrollMagic.Controller();

    keyFeaturesModule.forEach((element) => {
      const parentElem = element.closest('.sc-key-features');
      const innerEle = parentElem.querySelector('.key-features__inner');
      const headerEle = parentElem.querySelector('.key-features__header');
      const stickyElem = parentElem.querySelector('.key-features__sticky');
      const sliderStickyElem = parentElem.querySelector('.key-features__slider-sticky');
      const sliderEle = parentElem.querySelector('.key-features__slider');
      const sliderInnerEle = parentElem.querySelector('.key-features__slider-inner');
      const allFakeSlides = parentElem.querySelectorAll('.key-features__faker-item');

      const dummyWidth = windowWidth() >= 1511 ? 300 : windowWidth() >= breakpointMd ? 50 : 0;
      const totalScrollWidth = sliderInnerEle.scrollWidth;
      const viewportWidth = sliderEle.clientWidth;
      const totalDistance = totalScrollWidth - viewportWidth;

      const scrollDistance = -(totalDistance / sliderInnerEle.offsetWidth) * 100;

      const sliderTween = gsap.to(sliderInnerEle, {
        xPercent: scrollDistance,
        ease: 'none',
      });

      const animationDuration = totalDistance + dummyWidth;

      new ScrollMagic.Scene({
        triggerElement: sliderStickyElem,
        duration: animationDuration,
        triggerHook: 0,
      })
        .setPin(innerEle)
        .setTween(sliderTween)
        .addTo(keyFeaturesEle);

      // Header
      const titleEle = parentElem.querySelector('.key-features__title');
      const topSpacer = parentElem.querySelector('.key-features__top-spacer');

      const headerDuration = animationDuration + topSpacer.clientHeight + titleEle.clientHeight;

      new ScrollMagic.Scene({
        triggerElement: stickyElem,
        duration: headerDuration,
        triggerHook: 0,
      })
        .setPin(headerEle)
        .addTo(keyFeaturesEle);

      // Slides
      allFakeSlides.forEach((item) => {
        const itemIndex = parseInt(item.getAttribute('data-image'), 10);
        const targetContent = element.querySelector(`[data-target-slide="${itemIndex}"]`);
        const targetSlide = targetContent.closest('.key-features__slide');

        const slideTween = gsap.to(targetSlide, {
          y: 0,
          ease: 'none',
        });

        new ScrollMagic.Scene({
          triggerElement: item,
          duration: item.clientHeight,
          triggerHook: 0.8,
          reverse: true,
        })
          .setTween(slideTween)
          .addTo(keyFeaturesEle);
      });
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    initKeyFeaturesScrollMagic();
  });
}

// Mobile Slider
const keyFeaturesSlider = document.querySelectorAll('[data-slider="key-features-slider"]');

const keyFeaturesSliderOptions = {
  slidesPerView: 'auto',
  spaceBetween: 0,
  watchOverflow: true,
  freeMode: true,
  keyboard: {
    enabled: true,
    onlyInViewport: true,
  },
};

const initKeyFeaturesSlider = () => {
  keyFeaturesSlider.forEach((el) => {
    const parentEle = el.closest('.key-features');
    const slide = parentEle.querySelector('.key-features__mobile-slider');
    const slideHeightCalc = slide.getBoundingClientRect().height;
    parentEle.style.setProperty('--slide-height', `${slideHeightCalc}px`);

    if (windowWidth() > 767) {
      new Swiper(el, keyFeaturesSliderOptions);
    } else {
      enableScrollbarSync(parentEle);
    }
  });
};

initKeyFeaturesSlider();

setupResponsiveSliders({
  sliderElements: keyFeaturesSlider,
  breakpoint: 767,
  initSlider: initKeyFeaturesSlider,
  mobileFallback: enableScrollbarSync,
  parentSelector: '[data-slider-parent]',
});
